import { render } from "./agregarDocumento.vue?vue&type=template&id=245b846f&scoped=true"
import script from "./agregarDocumento.vue?vue&type=script&lang=js"
export * from "./agregarDocumento.vue?vue&type=script&lang=js"

import "./agregarDocumento.vue?vue&type=style&index=0&id=245b846f&lang=css"
import "./agregarDocumento.vue?vue&type=style&index=1&id=245b846f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245b846f"]])

export default __exports__